import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import EditionStageService from '@/services/httpTypescript/api/editionStage'
import { editionStageResponseSchema } from '@/schemas/edititionStage'
import { ZodError } from 'zod'
import { EditionStage } from '@/types'
import type { Router } from 'vue-router'

const useEditionStageStore = defineStore('editionStage', () => {
  const editionStage = ref<string>()
  const paymentAllowed = ref<boolean>(false)

  const getEditionStage = computed<EditionStage>(() => editionStage.value as EditionStage)
  const getPaymentAllowed = computed<boolean>(() => paymentAllowed.value)
  const isRetention = computed<boolean>(() => editionStage.value === EditionStage.retention)

  const fetchEditionStage = async (router: Router): Promise<void> => {
    try {
      const response = await EditionStageService.fetchEditionStage()
      await editionStageResponseSchema.parse(response.data)
      const responseValue = response.data.data
      editionStage.value = responseValue.stage
      paymentAllowed.value = responseValue.paymentAllowed
    } catch (error) {
      if (error instanceof ZodError) {
        throw error
      }
      // redirect to ClosedBefore if backend throw any other error
      router.push({ name: 'ClosedBefore' })
    }
  }

  return {
    editionStage,
    paymentAllowed,
    getEditionStage,
    getPaymentAllowed,
    isRetention,
    fetchEditionStage
  }
})

export default useEditionStageStore
